export default __webpack_public_path__ + "static/media/rs-sakura.f1378a41.jpg";